/**
 * retourHautPage.js
 */

// Import
import "./retourHautPage.scss";
import $ from 'jquery';

let $hauteurMinimum = $(window).height() * 2;

$( document ).ready(function() {
    $hauteurMinimum = $(window).height() * 2;
});

$( window ).resize(function() {
    $hauteurMinimum = $(window).height() * 2;
});

$(document).scroll(function(){
    if($(document).scrollTop()>$hauteurMinimum){
        $("a.retourHautPage").show();
    }else{
        $("a.retourHautPage").hide();
    }
});


